import { Link } from "react-router-dom";
import "../../Assets/Styles/AdminError.css";

function ErrorPage() {
  return (
    <div style={styles.overlay}>
      <div style={styles.messageBox}>
        <h1 style={styles.heading}>Oops! Something went wrong.</h1>
        <p style={styles.text}>The page you are looking for doesn't exist.</p>
        <Link className="btn" to={"/"}>
          Back to Home page
        </Link>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "#006CB8", // Bootstrap blue
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  messageBox: {
    textAlign: "center",
    maxWidth: "700px",
    padding: "20px",
    
  },
  heading: {
    fontSize: "2.5rem",
    marginBottom: "16px",
   
  },
  text: {
    fontSize: "1.2rem",
  },
};

export default ErrorPage;
